<template>
  <div>
    <site-plan-component></site-plan-component>
  </div>
</template>

<script setup lang="ts">
import SitePlanComponent from './components/SitePlanComponent.vue';

</script>

<style lang="scss">
body.modal-open{
  overflow: hidden;
}
#app {
  font-family: Roboto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #131E29;
}
@font-face {
    font-family: 'D-DIN Condensed';
    font-weight: 400;
    src: url('./assets/fonts/DIN-condensed.ttf');
}

@font-face {
    font-family: 'Helvetica';
    src: url('./assets/fonts/Helvetica.ttc');
}

@font-face {
  font-family: 'Palatino';
  src: url('./assets/fonts/Palatino.ttc');
}

@font-face {
  font-family: 'Brandon Groeteque Med';
  src: url('./assets/fonts/Brandon_med.otf');
}

@font-face {
  font-family: 'Brandon Groeteque Bold';
  src: url('./assets/fonts/Brandon_bld.otf');
}
@font-face {
  font-family: 'Arima Mandurai Bold';
  src: url('./assets/fonts/ArimaMadurai-Bold.ttf');
}

@font-face {
  font-family: 'The Farmer Original';
  src: url('./assets/fonts/TheFarmerOriginalRegular.ttf');
}
@font-face {
  font-family: 'Gilroy-SemiBold';
  font-weight: 600;
  src: url('./assets/fonts/Gilroy-SemiBold.ttf');
}

@font-face {
  font-family: 'Canela Web';
  src: url('./assets/fonts/Canela-Light-Web.woff2') format('woff2'),
       url('./assets/fonts/Canela-Light-Web.woff') format('woff');
  font-weight:  300;
  font-style:   normal;
  font-stretch: normal;
}
@font-face {
  font-family: 'SangBleu OG Bold';
  src: url('./assets/fonts/SangBleuOGSans-Bold-WebXL.woff2') format('woff2'),
       url('./assets/fonts/SangBleuOGSans-Bold-WebXL.woff') format('woff');
  font-weight: 700;
}

@font-face {
  font-family: 'SangBleu OG';
  src: url('./assets/fonts/SangBleuOGSans-Regular-WebXL.woff2') format('woff2'),
       url('./assets/fonts/SangBleuOGSans-Regular-WebXL.woff') format('woff');
  font-weight: 500;
}
</style>
